<template>
    <div class="inspection-report">
        <div class="header flex mb-6">
            <div class="flex-1" style="word-wrap: break-word; min-width: 1%;">
                <h1 class="text-3xl">{{ resource.checklist_title }}</h1>
                <p
                    v-if="resource.template.display_description"
                    class="mt-1 text-60 whitespace-pre-line">
                    {{ resource.checklist_description }}
                </p>
            </div>
            <div
                v-if="resource.template.logo"
                style="width: 10rem"
            >
                <img
                    class="logo"
                    style="max-width: 100%;"
                    :src="resource.template.logo"
                />
            </div>
        </div>
        <div class="form">
            <Item
                :item="resource.form"
                :resource="resource"
            />
        </div>
    </div>
</template>

<script>
    import OnFreePlan from '@/mixins/OnFreePlan';
    import Item from '@/components/InspectionReport/Items/Item';

    export default {
        components: { Item },

        props: {
            resource: {
                type: Object,
                required: true,
            },
        },

        mixins: [OnFreePlan],
    };
</script>
